import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { useCurrentUser } from "../../Queries/UserQueries";
import { useAppSelector } from "./reduxHooks";
import { selectClientValue } from "../Slices/SelectedClientSlice";

export const useFeatureToggles = () => {
  const launchDarklyClient = useLDClient();
  const currentUser = useCurrentUser();
  const client = useAppSelector(selectClientValue);

  //updates the context once a user has logged in
  useEffect(() => {
    if (launchDarklyClient && currentUser?.id && client.clientId) {
      launchDarklyClient.identify({
        kind: "multi",
        user: {
          key: currentUser?.id,
          name: currentUser?.name,
          email: currentUser?.email,
        },
        "crm-client": {
          key: client.clientId,
          name: client.clientName,
        },
      });
    }
  }, [
    currentUser?.email,
    currentUser?.id,
    currentUser?.name,
    client.clientId,
    client.clientName,
    launchDarklyClient,
  ]);

  return;
};
